module.exports = __webpack_public_path__ + "img/cooperative0_logo24.27e4f518.jpg";